import React, { useEffect, useState } from 'react';
import { Modal } from './ui/modal';
import { fetchWithRetry } from '../utils/tourUtils';
import { FUNCTION_NAMES } from '../constants';
import LocationSelector from './LocationSelector';
import ContractorSelector from './ContractorSelector';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Button } from './ui/button';
import { toast } from './ui/use-toast';
import { API_BASE_URL } from '../config';
import LocationSelectorBase from './LocationSelectorBase';

const EditTourModal = ({ isOpen, onClose, selectedTour, onUpdateTourFields }) => {
  const [editorState, setEditorState] = useState({
    projectId: '',
    lotId: '',
    buildingId: '',
    floorId: '',
    spaceId: '',
    contractorId: '',
    tourType: '',
  });

  useEffect(() => {
    if (selectedTour) {
      debugger;
      setEditorState({
        projectId: selectedTour.projectId || '',
        lotId: selectedTour.lotId || '',
        buildingId: selectedTour.buildingId || '',
        floorId: selectedTour.floorId || '',
        spaceId: selectedTour.spaceId || '',
        contractorId: selectedTour.contractors[0].contractorId || '',
        tourType: selectedTour.tourType || '',
      });
    }
  }, [selectedTour]);

  const updateField = (field, value) => {
    setEditorState(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      // Before saving, regenerate tour name
      const parts = [
        editorState.projectId,
        editorState.lotId,
        editorState.buildingId,
        editorState.floorId,
        editorState.spaceId,
      ].filter(Boolean);
      const tourName = parts.join('_');
      debugger;
      const dataToSave = {
        ...editorState,
        name: tourName, // ⬅️ add regenerated name
      };

      await fetchWithRetry({
        url: `${API_BASE_URL}/api/post`,
        data: {
          function_name: FUNCTION_NAMES.PRISMA,
          operation: 'tour.update',
          payload: {
            id: selectedTour.id,
            data: dataToSave,
          },
        },
        label: 'saving tour fields',
        throwError: true,
      });

      toast({ title: 'Success', description: 'Tour fields updated successfully' });
      onUpdateTourFields?.(); // refresh parent if needed
      onClose();
    } catch (error) {
      toast({ title: 'Error', description: 'Failed to save tour fields', variant: 'destructive' });
    }
  };

  if (!selectedTour) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Tour Fields">
      <div className="space-y-4 p-4">
        <LocationSelectorBase
          clientId={selectedTour.clientId}
          projectId={editorState.projectId}
          lotId={editorState.lotId}
          buildingId={editorState.buildingId}
          floorId={editorState.floorId}
          spaceId={editorState.spaceId}
          onChange={({ projectId, lotId, buildingId, floorId, spaceId }) => {
            updateField('projectId', projectId);
            updateField('lotId', lotId);
            updateField('buildingId', buildingId);
            updateField('floorId', floorId);
            updateField('spaceId', spaceId);
          }}
        />

        <Select
          value={editorState.tourType}
          onValueChange={value => updateField('tourType', value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select Tour Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="TRUM_TICHNON">תרום תכנון</SelectItem>
            <SelectItem value="TICHNON_VS_BITZUA">תכנון מול ביצוע</SelectItem>
            <SelectItem value="TIUD_MESIRA">תיעוד מסירה</SelectItem>
          </SelectContent>
        </Select>

        <ContractorSelector
          value={editorState.contractorId}
          onChange={value => updateField('contractorId', value)}
          hideAdd={true}
        />

        <Button disabled={!editorState.spaceId} className="w-full mt-4" onClick={handleSave}>
          Save Changes
        </Button>
      </div>
    </Modal>
  );
};

export default EditTourModal;
